export enum CommonMutationTypes {
  SET_MONEY_TYPE = 'SET_MONEY_TYPE',
  SET_EXCHANGE_RATE = 'SET_EXCHANGE_RATE'
}
